import React from "react";
import { Question, QuestionBasic } from "../../@types/question.interface";
import "./preview-question.styles.scss";
import QuestionContent from "../question-content/question-content.component";

interface IProps {
    question: Question | QuestionBasic;
}

export default function PreviewQuestion({ question }: IProps) {
    return (
        <div className="preview">
            <div className="preview__label">
                <span>Preview</span>
            </div>
            <QuestionContent question={question} />
        </div>
    );
}
